export default {
  'form-step-form.basic.title': 'Basic form',
  'form-step-form.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'form-step-form.email.required': 'Please enter your email!',
  'form-step-form.email.wrong-format': 'The email address is in the wrong format!',
  'form-step-form.userName.required': 'Please enter your userName!',
  'form-step-form.password.required': 'Please enter your password!',
  'form-step-form.password.twice': 'The passwords entered twice do not match!',
  'form-step-form.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'form-step-form.strength.strong': 'Strength: strong',
  'form-step-form.strength.medium': 'Strength: medium',
  'form-step-form.strength.short': 'Strength: too short',
  'form-step-form.confirm-password.required': 'Please confirm your password!',
  'form-step-form.phone-number.required': 'Please enter your phone number!',
  'form-step-form.phone-number.wrong-format': 'Malformed phone number!',
  'form-step-form.verification-code.required': 'Please enter the verification code!',
  'form-step-form.title.required': 'Please enter a title',
  'form-step-form.date.required': 'Please select the start and end date',
  'form-step-form.goal.required': 'Please enter a description of the goal',
  'form-step-form.standard.required': 'Please enter a metric',

  'form-step-form.form.get-captcha': 'Get Captcha',
  'form-step-form.captcha.second': 'sec',
  'form-step-form.form.optional': ' (optional) ',
  'form-step-form.form.submit': 'Submit',
  'form-step-form.form.save': 'Save',
  'form-step-form.email.placeholder': 'Email',
  'form-step-form.password.placeholder': 'Password',
  'form-step-form.confirm-password.placeholder': 'Confirm password',
  'form-step-form.phone-number.placeholder': 'Phone number',
  'form-step-form.verification-code.placeholder': 'Verification code',
  'form-step-form.title.label': 'Title',
  'form-step-form.title.placeholder': 'Give the target a name',
  'form-step-form.date.label': 'Start and end date',
  'form-step-form.placeholder.start': 'Start date',
  'form-step-form.placeholder.end': 'End date',
  'form-step-form.goal.label': 'Goal description',
  'form-step-form.goal.placeholder': 'Please enter your work goals',
  'form-step-form.standard.label': 'Metrics',
  'form-step-form.standard.placeholder': 'Please enter a metric',
  'form-step-form.client.label': 'Client',
  'form-step-form.label.tooltip': 'Target service object',
  'form-step-form.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'form-step-form.invites.label': 'Inviting critics',
  'form-step-form.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'form-step-form.weight.label': 'Weight',
  'form-step-form.weight.placeholder': 'Please enter weight',
  'form-step-form.public.label': 'Target disclosure',
  'form-step-form.label.help': 'Customers and invitees are shared by default',
  'form-step-form.radio.public': 'Public',
  'form-step-form.radio.partially-public': 'Partially public',
  'form-step-form.radio.private': 'Private',
  'form-step-form.publicUsers.placeholder': 'Open to',
  'form-step-form.option.A': 'Colleague A',
  'form-step-form.option.B': 'Colleague B',
  'form-step-form.option.C': 'Colleague C',
};
